import { ProductHit } from "@/components/products-tile/product";
import { toggleItemForComparison } from "@/store/compareProductsSlice";
import { AppState } from "@/store/store";
import { useCallback } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import styles from "./productsGrid.module.scss";

type CompareProductCheckboxProps = { hit: ProductHit };

const CompareProductCheckbox = ({ hit }: CompareProductCheckboxProps) => {
  const dispatch = useDispatch();

  const addedForCompare = useSelector((state: AppState) => {
    return !!state.compareProductsSlice.find((item: ProductHit) => item.mp_id === hit.mp_id);
  });

  const canAddForComparison = useSelector((state: AppState) => {
    return state.compareProductsSlice.length < 4;
  });

  const toggleAddForComparison = useCallback(() => {
    dispatch(toggleItemForComparison(hit));
  }, [dispatch, hit]);

  return (
    <Form.Group controlId={`product-${hit.mp_id}`} className={styles.compareProductCheckBox}>
      <Form.Check className="custom-checkbox inverted">
        <Form.Check.Input
          disabled={!canAddForComparison && !addedForCompare}
          type="checkbox"
          checked={addedForCompare}
          onChange={toggleAddForComparison}
        />
        <Form.Check.Label>Compare</Form.Check.Label>
      </Form.Check>
    </Form.Group>
  );
};

export default CompareProductCheckbox;
